import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";
import { useI18n, getConsent } from "@/context/I18nContext";

const save = (choice) => {
  const c = { necessary: true, ...choice, at: new Date().toISOString(), version: "1" };
  localStorage.setItem("clipx_consent", JSON.stringify(c));
  if (!c.analytics) window.posthog?.opt_out_capturing?.();
  else window.posthog?.opt_in_capturing?.();
  window.dispatchEvent(new Event("clipx-consent"));
  api.post("/privacy/consent", { choice: { preferences: c.preferences, analytics: c.analytics }, version: "1" }).catch(() => {});
  window.dispatchEvent(new Event("clipx-consent"));
};

export const openCookieSettings = () => window.dispatchEvent(new Event("clipx-open-cookies"));

export const CookieConsent = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(!getConsent());
  const [custom, setCustom] = useState(false);
  const [c, setC] = useState({ preferences: true, analytics: false });

  useEffect(() => {
    const o = () => { setC({ preferences: !!getConsent()?.preferences, analytics: !!getConsent()?.analytics }); setCustom(true); setOpen(true); };
    window.addEventListener("clipx-open-cookies", o);
    return () => window.removeEventListener("clipx-open-cookies", o);
  }, []);

  if (!open) return null;
  const done = (choice) => { save(choice); setOpen(false); };

  return (
    <div className="fixed z-[65] bottom-20 md:bottom-6 left-3 right-3 md:right-auto md:left-[100px] lg:left-[280px] md:w-[440px] cx-glass rounded-2xl p-5 shadow-[0_20px_60px_-10px_rgba(0,0,0,0.8)] border border-[#a746ff]/30 cx-rise" data-testid="cookie-banner">
      <div className="flex items-center gap-2 font-display font-semibold text-white"><ShieldCheck className="w-4 h-4 text-[#3ad7ff]" /> {t("ck.title")}</div>
      <p className="text-xs text-slate-300 mt-2 leading-relaxed">{t("ck.text")} <Link to="/confidentialite" className="text-[#3ad7ff] underline" data-testid="cookie-policy-link">{t("ck.policy")}</Link></p>
      {custom && (
        <div className="mt-4 space-y-3 text-xs text-slate-300" data-testid="cookie-custom-panel">
          <label className="flex items-center justify-between gap-3 opacity-70"><span>{t("ck.necessary")}</span><Switch checked disabled /></label>
          <label className="flex items-center justify-between gap-3"><span>{t("ck.preferences")}</span><Switch checked={c.preferences} onCheckedChange={(v) => setC({ ...c, preferences: v })} data-testid="cookie-preferences-switch" /></label>
          <label className="flex items-center justify-between gap-3"><span>{t("ck.analytics")}</span><Switch checked={c.analytics} onCheckedChange={(v) => setC({ ...c, analytics: v })} data-testid="cookie-analytics-switch" /></label>
        </div>
      )}
      <div className="grid grid-cols-3 gap-2 mt-4">
        <button data-testid="cookie-refuse-btn" onClick={() => done({ preferences: false, analytics: false })} className="cx-ghost rounded-full py-2 text-xs text-white">{t("ck.refuse")}</button>
        {custom ? (
          <button data-testid="cookie-save-btn" onClick={() => done(c)} className="cx-ghost rounded-full py-2 text-xs text-white">{t("ck.save")}</button>
        ) : (
          <button data-testid="cookie-custom-btn" onClick={() => setCustom(true)} className="cx-ghost rounded-full py-2 text-xs text-white">{t("ck.custom")}</button>
        )}
        <button data-testid="cookie-accept-btn" onClick={() => done({ preferences: true, analytics: true })} className="cx-btn rounded-full py-2 text-xs font-semibold">{t("ck.accept")}</button>
      </div>
    </div>
  );
};
